import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Contact from "../components/Contact";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);
const withTranslationComponent = withTranslation(["contact", "userActivities", "common"])(connectedComponent);

export default withTranslationComponent;



// WEBPACK FOOTER //
// ./src/containers/Contact.js